import { z } from 'zod';
import { BaseStatFilterSchema } from '../../../schemas';
import { useMergedProvincesChartQuery } from './useProvincesQuery';

interface UseMergedProvincesChartParams {
	filters?: z.infer<typeof BaseStatFilterSchema>;
}

export const useMergedProvincesChart = (params?: UseMergedProvincesChartParams) => {
	const { data: nivoData, isLoading, error } = useMergedProvincesChartQuery(params);

	return {
		nivoData: nivoData?.data || null,
		isLoading,
		error
	};
};
